<template>
  <div class="article-item" @click="$emit('click')">
    <!-- 卡片容器 -->
    <div class="article-card">
      <!-- 标题区域 -->
      <div class="article-header">
        <h3 class="article-title">{{ article.title }}</h3>
        <!-- 关键词标签 -->
        <div class="keywords-wrap" v-if="article.keywords">
          <span
              class="keyword-tag"
              v-for="(kw, index) in article.keywords.split('，')"
              :key="index"
          >
            {{ kw }}
          </span>
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="article-content">

        <!-- 元信息栏 -->
        <div class="article-meta">
          <div class="meta-left">
            <span class="author">
              <i class="icon-user"></i> {{ article.workName }}
            </span>
            <span class="time">
              <i class="icon-time"></i> {{ article.updateTime }}
            </span>
          </div>
          <div class="meta-right">
            <span class="visits">
              <i class="icon-eye"></i> {{ article.visits || 0 }} 浏览
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArticleItem',
  props: {
    article: {
      type: Object,
      required: true,
      default: () => ({
        title: '无标题',
        workName: '未知作者',
        updateTime: '暂无时间',
        keywords: '',
        visits: 0,
        description: ''
      })
    }
  }
}
</script>

<style scoped>
.article-item {
  padding: 12px;
  transition: transform 0.2s ease;
}

.article-item:hover {
  transform: translateY(-3px);
}

/* 卡片样式 */
.article-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease;
}

.article-item:hover .article-card {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

/* 标题区域 */
.article-header {
  margin-bottom: 16px;
}

.article-title {
  font-size: 20px;
  color: #2c3e50;
  margin: 0 0 10px 0;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 关键词标签 */
.keywords-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.keyword-tag {
  font-size: 12px;
  padding: 3px 10px;
  background: #f0f5ff;
  color: #4096ff;
  border-radius: 12px;
  white-space: nowrap;
}

/* 内容区域 */
.article-content {
  position: relative;
}


/* 元信息栏 */
.article-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px dashed #eee;
  font-size: 13px;
  color: #999;
}

.meta-left {
  display: flex;
  gap: 20px;
}

.meta-right {
  display: flex;
  align-items: center;
}

/* 图标样式（模拟） */
.icon-user::before {
  content: "👤";
  margin-right: 4px;
}

.icon-time::before {
  content: "🕒";
  margin-right: 4px;
}

.icon-eye::before {
  content: "👁️";
  margin-right: 4px;
}

.author, .time, .visits {
  display: flex;
  align-items: center;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .article-card {
    padding: 16px;
  }

  .article-title {
    font-size: 18px;
  }

  .article-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>